/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Continue_With_ProviderInputs */

const en_auth_continue_with_provider = /** @type {(inputs: Auth_Continue_With_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with`)
};

const es_auth_continue_with_provider = /** @type {(inputs: Auth_Continue_With_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar con`)
};

/**
* | output |
* | --- |
* | "Continue with" |
*
* @param {Auth_Continue_With_ProviderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_continue_with_provider = /** @type {((inputs?: Auth_Continue_With_ProviderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Continue_With_ProviderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_continue_with_provider(inputs)
	return en_auth_continue_with_provider(inputs)
});